import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

import useMutateApi from '../../api/hooks/useMutateApi';
import { COMMENT } from '../../constants/endpoints';
import { COMMENTS_EDIT } from '../../constants/actions';
import { newError } from '../../actions/errors';
import updateCommentInQueryData from '../utils/updateCommentInQueryData';
import formatUser from '../../api/posts/formatUser';

const useEditComment = (comment) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutateApi(
    {
      url: COMMENT(comment.id),
      method: 'PUT',
    },
    {
      onMutate: async () => {
        dispatch({ type: COMMENTS_EDIT, status: 'started' });
      },
      onSuccess: ({ comment: editedComment }) => {
        const formattedComment = {
          ...editedComment,
          user: formatUser(editedComment.user),
        };
        updateCommentInQueryData(queryClient, formattedComment);
        dispatch({
          type: COMMENTS_EDIT,
          status: 'success',
          comment: formattedComment,
        });
      },
      onError: (error) => {
        dispatch(newError(error, 'editCommentError'));
        dispatch({ type: COMMENTS_EDIT, status: 'error', error });
      },
    }
  );
};

export default useEditComment;
